import { render, staticRenderFns } from "./dropdown-btn.vue?vue&type=template&id=08396b84&"
import script from "./dropdown-btn.vue?vue&type=script&lang=js&"
export * from "./dropdown-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports